export class Utils{

    static patronNumeric: RegExp = /[0-9]/;

         /** Función que ajusta la fecha para que vaya correctamente */
      static adjustDateForTimeOffset(dateToAdjust:Date): Date {

        if (dateToAdjust!=null){
          try{
            var offsetMs = dateToAdjust.getTimezoneOffset() * 60000;
            return new Date(dateToAdjust.getTime() - offsetMs);
          }catch {
              return dateToAdjust;
          }
        }

      return null;
  }


  static capitalize(word) {
    return word[0].toUpperCase() + word.slice(1);
  }

   static removeNonNumeric(event: any): boolean {
    let tecla = event.keyCode;

    //Se permite siempre el borrado
    if(tecla == 8){
      return true;
    }

    //let tecla_final = String.fromCharCode(tecla);

    if (isNaN(event.key)) {
      return false
    }else{
      return true;
    }

    //return this.patronNumeric.test(tecla_final);
  }

}
